import { CURATED_CATEGORY_TAG_MAP } from './models';

// This function is used to sanitize the text that is used to create the pill
// in the CuratedCategory component. It removes whitespaces and special
// characters from the beginning and end of the string.
export const sanitizeText = (text: string) =>
    text.trim().replace(/^[\W_]+|[\W_]+$/g, '');

export const getCuratedCategoryTag = (categoryText: string) =>
    Object.keys(CURATED_CATEGORY_TAG_MAP).find(
        (key) =>
            CURATED_CATEGORY_TAG_MAP[
                key as keyof typeof CURATED_CATEGORY_TAG_MAP
            ].text === categoryText,
    );

export const getCuratedCategoryText = (
    categoryKey: keyof typeof CURATED_CATEGORY_TAG_MAP,
) => {
    const curatedCategory = CURATED_CATEGORY_TAG_MAP[categoryKey];
    return `${curatedCategory.emoji} ${curatedCategory.text}`;
};
